import { styled } from '@mui/system';

const StyledRadiusInputRoot = styled('div')({
  display: 'flex',
  width: '30%',
  height: '40px',
  boxSizing: 'border-box',
  fontSize: '14px',
  alignItems: 'center',
  gap: '8px',
  borderRadius: '4px',
  padding: '0 12px',
  border: '1px solid rgba(0, 0, 0, 0.23)',
  backgroundColor: 'rgb(250 250 250)',
  transition: 'border-color 0.2s, box-shadow 0.2s',
  '&:hover': {
    borderColor: 'rgba(0, 0, 0, 0.87)',
  },
  '&:focus-within': {
    borderColor: '#1976d2',
    borderWidth: '2px',
    padding: '0 11px',
  },
  '& input': {
    width: '100%',
    outline: 'none',
    backgroundColor: 'rgb(250 250 250)',
    border: 'none',
    fontSize: '14px',
  },
});

export default StyledRadiusInputRoot;
